export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0143"] = "acq-0143";
  ExperimentKeys["ACQ0145"] = "acq-0145";
  ExperimentKeys["ACQ0148"] = "acq-0148";
  ExperimentKeys["COAC0001"] = "coac-0001";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';